import * as React from "react";

export const useModal = (initialMode = false) => {
  const [isVisible, setModalOpen] = React.useState(initialMode);
  const toggle = React.useCallback(() => setModalOpen((prev) => !prev), []);
  return { isVisible, toggle };
};
